import React from 'react';

import { useTranslation } from 'react-i18next';

import {
  DeltaValue,
  GammaValue,
  ThetaValue,
  VeggaValue,
} from 'components/options_chain/helpers';
import { Product } from 'types/IProducts';

import styles from './styles.module.scss';

interface Props {
  selectedProduct: Product;
}

const MobileGreeks = ({ selectedProduct }: Props) => {
  const { t } = useTranslation(['trading']);
  return (
    (<div className={styles['mobile-greeks']} data-palette="MobileGreeks">
      <div className={styles['greeks-header']}>Greeks</div>
      <div className="row">
        <div className="col-xxs-8 mt-2">
          <div className={styles['greeks-label']}>{t('trading:delta')}</div>
          <div className={styles['greeks-value']}>
            <DeltaValue {...selectedProduct} />
          </div>
        </div>
        <div className="col-xxs-8 mt-2">
          <div className={styles['greeks-label']}>{t('trading:gamma')}</div>
          <div className={styles['greeks-value']}>
            <GammaValue {...selectedProduct} />
          </div>
        </div>
        <div className="col-xxs-8 mt-2">
          <div className={styles['greeks-label']}>{t('trading:vega')}</div>
          <div className={styles['greeks-value']}>
            <VeggaValue {...selectedProduct} />
          </div>
        </div>
        <div className="col-xxs-8 mt-2">
          <div className={styles['greeks-label']}>{t('trading:theta')}</div>
          <div className={styles['greeks-value']}>
            <ThetaValue {...selectedProduct} />
          </div>
        </div>
      </div>
    </div>)
  );
};

export default MobileGreeks;
